/**
 * The portal's one way to report a problem we didn't expect (the only place allowed to use console).
 * Error reporting (e.g. Sentry) plugs in here later, so callers don't change.
 */
export const log = {
  warn(message: string, detail?: unknown): void {
    console.warn(`[brocoly] ${message}`, detail);
  },
};
